module.exports = __webpack_public_path__ + "static/media/jewel.5afe8309.gif";